export default __webpack_public_path__ + "static/media/searchPage_placeholder_img.f41d2a94.png";